import { render, staticRenderFns } from "./prjActionDialog.vue?vue&type=template&id=3b6db395"
import script from "./prjActionDialog.vue?vue&type=script&lang=js"
export * from "./prjActionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports